import cn from 'classnames'
import { MouseEvent, useState } from 'react'

import { Translation } from 'cng-common/features/translations/components/translation'
import { Button } from 'core-components/library/button'
import { AbsolutePopup, PopPaper, TPopupVertical } from 'core-components/library/popup'
import { FINANCIAL_COCKPIT_TRANSLATION_KEYS } from 'partner360/features/financialCockpit/configs/translations'

import type { ICockpitCategoryOption } from '../../../model'

import styles from './CategoryDropdown.module.scss'

interface ICategoryDropdownProps {
  categories: ICockpitCategoryOption[]
  selectedCategory: string | null
  onChange: (category: string | null) => void
}

export const CategoryDropdown = ({
  categories,
  selectedCategory,
  onChange,
}: ICategoryDropdownProps) => {
  const [isOpened, setOpened] = useState(false)

  const stopTabSelection = (event: MouseEvent) => event.stopPropagation()

  return (
    <span className={styles.root} onClick={stopTabSelection}>
      <AbsolutePopup
        rootClassName={styles.popupRoot}
        popupClassName={styles.popupWrap}
        verticalStartPosition={TPopupVertical.Bottom}
        visibilityCallback={(visible) => {
          setOpened(visible)
          return visible
        }}
        popupContent={({ action }) => (
          <PopPaper shadowPosition="auto" className={styles.popup}>
            <div className={styles.options} role="listbox" aria-label="Category">
              <div className={styles.label}>
                <Translation
                  text={FINANCIAL_COCKPIT_TRANSLATION_KEYS.programTypes.categoryDropdownLabel}
                  span
                />
              </div>

              <button
                type="button"
                className={cn(styles.option, { [styles.selected]: selectedCategory === null })}
                onClick={() => {
                  onChange(null)
                  setOpened(false)
                  action.close()
                }}
              >
                <Translation
                  text={FINANCIAL_COCKPIT_TRANSLATION_KEYS.programTypes.allCategories}
                  span
                />
                {selectedCategory === null && <i className="kbase kbase-check" />}
              </button>

              {categories.map(({ category }) => {
                const isSelected = category === selectedCategory

                return (
                  <button
                    key={category}
                    type="button"
                    className={cn(styles.option, { [styles.selected]: isSelected })}
                    onClick={() => {
                      onChange(category)
                      setOpened(false)
                      action.close()
                    }}
                  >
                    <Translation text={category} span />
                    {isSelected && <i className="kbase kbase-check" />}
                  </button>
                )
              })}
            </div>
          </PopPaper>
        )}
      >
        <Button
          className={styles.trigger}
          variant="text"
          size="sm"
          iconButton={`kbase ${isOpened ? 'kbase-chevron-top' : 'kbase-chevron-bottom'}`}
        />
      </AbsolutePopup>
    </span>
  )
}
